import _ from "lodash";

export const snakeToCamel = <T>(obj: T): T => {
	if (_.isArray(obj)) {
		return obj.map((v) => snakeToCamel(v)) as unknown as T;
	} else if (_.isObject(obj) && !(obj instanceof Date)) {
		return _.reduce(
			obj as Record<string, any>,
			(result, value, key) => {
				const newKey = _.camelCase(key);
				(result as Record<string, any>)[newKey] = snakeToCamel(value);
				return result;
			},
			{} as Record<string, any>
		) as unknown as T;
	}
	return obj;
};

export const camelToSnake = <T>(obj: T): T => {
	if (_.isArray(obj)) {
		return obj.map((v) => camelToSnake(v)) as unknown as T;
	} else if (_.isObject(obj) && !(obj instanceof Date)) {
		return _.reduce(
			obj as Record<string, any>,
			(result, value, key) => {
				const newKey = _.snakeCase(key);
				(result as Record<string, any>)[newKey] = camelToSnake(value);
				return result;
			},
			{} as Record<string, any>
		) as unknown as T;
	}
	return obj;
};
